"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosAgentUsageSchema = void 0;
const zod_1 = require("zod");
const id_schema_1 = require("../../common/id.schema");
const agent_memory_schema_1 = require("./agent-memory.schema");
exports.APosAgentUsageSchema = zod_1.z.object({
    tenantId: id_schema_1.TenantIdSchema,
    usageId: id_schema_1.EntityIdSchema,
    agentType: agent_memory_schema_1.APosAgentTypeSchema,
    locationId: id_schema_1.EntityIdSchema.optional(),
    action: zod_1.z.string().min(1).max(200),
    inputTokens: zod_1.z.number().int().nonnegative().default(0),
    outputTokens: zod_1.z.number().int().nonnegative().default(0),
    totalTokens: zod_1.z.number().int().nonnegative().default(0),
    model: zod_1.z.string().optional(),
    durationMs: zod_1.z.number().int().nonnegative().optional(),
    cost: zod_1.z.number().nonnegative().optional(),
    success: zod_1.z.boolean().default(true),
    errorMessage: zod_1.z.string().max(2000).optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    timestamp: zod_1.z.number(),
});
//# sourceMappingURL=agent-usage.schema.js.map